import { j as o } from "./jsx-runtime-3tyXYecC.mjs";
import { B as c, a as C, S as O, U as y, O as f, T as H, C as U, F as A, H as B, L as N } from "./upper-content-BgC1jI-u.mjs";
import { f as t } from "./index-LyFokDcn.mjs";
import { C as $ } from "./card-vPwejA0-.mjs";
import { b as h, a as E, C as d } from "./enums-BtUzbEmn.mjs";
import { u as g } from "./hooks-nrLF1Lxr.mjs";
import { r as S } from "./index-lgh2EImO.mjs";
import { m as l } from "./tss-DN0acMKN.mjs";
import { M as z, d as T } from "./constants-CnFYFetN.mjs";
import { g as D, D as w } from "./default-header-BKiY8R2J.mjs";
import { C as R } from "./content-iXOVBfdp.mjs";
import { H as I } from "./headline-DF2GOgMa.mjs";
import { u as W } from "./use-screen-sizes-hx44ztp3.mjs";
var m = /* @__PURE__ */ ((e) => (e.CUSTOM = "custom", e.LARGE = "large", e.MEDIUM = "medium", e.SMALL = "small", e))(m || {});
function k(e) {
  return Object.values(m).includes(e);
}
const P = (e) => ({
  alignItems: "center",
  display: "flex",
  paddingBottom: "16px",
  // 16px + Footer Constraint.spacingOverrides.bottom @ ContentSpacing.small (16px) = 32px;
  paddingTop: "14px",
  // 2px divider + 12px = 14px. 14px + 12px footer action margin = 26px (24px negative space)
  position: "relative",
  // for divider pseudo-element
  "&:before": {
    background: `linear-gradient(90deg, ${e.lightest} 0, ${e.lighter} 100%)`,
    content: '""',
    display: "block",
    height: "2px",
    left: 0,
    position: "absolute",
    top: 0,
    width: "100%"
  }
}), G = l()(({ constructs: e, mixins: r, mode: a, palette: s, spacing: i }) => ({
  root: {
    borderRadius: t.ifFeature("encore", "16px"),
    backgroundColor: t.ifFeature("encore", s.common.white),
    alignSelf: "center",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    maxHeight: "90vh",
    padding: t.ifFeature("encore", "4px", i(3)),
    width: "100%",
    outline: a === z.Dye ? `1px solid ${T.main}` : void 0,
    boxShadow: t.ifFeature("encore", `2px 2px 0px 2px ${r.alpha(e.surface.neutral.xxStrong, 0.05)}`),
    "@media print": {
      maxWidth: "100%"
      // The modal is too wide when printing and this forces the modal to fit on the screen when printing
    }
  },
  sizeSmall: {
    maxWidth: `calc(528px + ${i(6)})`
  },
  sizeMedium: {
    maxWidth: `calc(720px + ${i(6)})`
  },
  sizeLarge: {
    maxWidth: `calc(912px + ${i(6)})`
  }
})), M = (e) => {
  const { classes: r, cx: a } = G(), { children: s, renderHeader: i, renderFooter: F, size: u = m.SMALL, ...L } = e, { isMediumScreen: j } = g(), p = S(F), x = S(i), b = /* @__PURE__ */ o.jsx($, { flex: h.COLUMN, hasBottomGradient: !1, size: E.CUSTOM, children: /* @__PURE__ */ o.jsxs(
    R,
    {
      canOverflow: !1,
      flex: h.COLUMN,
      spacingOverrides: {
        bottom: d.NONE,
        left: d.MEDIUM,
        right: d.MEDIUM,
        top: d.NONE
      },
      children: [
        s,
        p
      ]
    }
  ) }), v = s;
  return /* @__PURE__ */ o.jsx(c.Body, { ...L, children: /* @__PURE__ */ o.jsxs(
    "div",
    {
      className: a(r.root, {
        [r[D(u)]]: !j && k(u)
      }),
      children: [
        t.ifFeature("encore", x || /* @__PURE__ */ o.jsx(w, { hasCloseButton: !0 }), x),
        t.ifFeature("encore", v, b),
        t.ifFeature("encore", p)
      ]
    }
  ) });
};
M.Size = m;
const _ = l()(({ breakpoints: e, palette: r, spacing: a }) => ({
  root: t.ifFeature(
    "encore",
    {
      backgroundColor: r.gray[50],
      borderBottomLeftRadius: "12px",
      borderBottomRightRadius: "12px",
      padding: "16px 20px",
      [e.down("sm")]: {
        padding: a(2)
      }
    },
    P(r.primary)
  ),
  mobile: {
    alignItems: "stretch",
    flexDirection: "column"
  }
})), Q = (e) => {
  const { classes: r, cx: a } = _(), { isMediumScreen: s } = g();
  return /* @__PURE__ */ o.jsx(
    "div",
    {
      className: a(r.root, {
        [r.mobile]: s
      }),
      children: t.ifFeature(
        "encore",
        /* @__PURE__ */ o.jsx(c.Footer, { ...e, minActionWidth: s ? 100 : void 0 }),
        /* @__PURE__ */ o.jsx(
          C,
          {
            spacingOverrides: {
              bottom: d.SMALL,
              left: d.SMALL,
              right: d.SMALL,
              top: d.NONE
            },
            children: /* @__PURE__ */ o.jsx(c.Footer, { ...e, minActionWidth: s ? 100 : void 0 })
          }
        )
      )
    }
  );
}, Y = (e) => {
  const { children: r, title: a, ...s } = e, { isMediumScreen: i } = W(!0);
  return /* @__PURE__ */ o.jsx(c.Header, { ...s, children: r || t.ifFeature(
    "encore",
    /* @__PURE__ */ o.jsx(I, { color: "primary", size: i ? "small" : "medium", children: a }),
    /* @__PURE__ */ o.jsx("h4", { children: a })
  ) });
}, Z = l()(() => ({
  root: {
    marginTop: t.ifFeature("encore", void 0, "20px")
  }
})), q = (e) => {
  const { classes: r } = Z();
  return /* @__PURE__ */ o.jsx("div", { className: r.root, children: /* @__PURE__ */ o.jsx(O, { ...e }) });
}, J = l()(() => ({
  root: {
    marginTop: t.ifFeature("encore", void 0, "20px")
  }
})), K = (e) => {
  const { classes: r } = J();
  return /* @__PURE__ */ o.jsx("div", { className: r.root, children: /* @__PURE__ */ o.jsx(y, { ...e }) });
}, n = (e) => /* @__PURE__ */ o.jsx(
  c,
  {
    ...e,
    "data-fabric-component": "SheetModal",
    overlayTheme: t.ifFeature("encore", f.FULLY_OPAQUE, f.PARTIALLY_OPAQUE),
    transition: H.ZOOM_FADE
  }
);
n.Body = M;
n.CloseButton = c.CloseButton;
n.ConfirmationContent = U;
n.Constraint = C;
n.FocalContent = A;
n.Footer = Q;
n.Header = Y;
n.HeroHeadline = B;
n.LowerContent = N;
n.StandardHeadline = q;
n.UpperContent = K;
export {
  m as B,
  n as S
};
//# sourceMappingURL=sheet-modal-tzVjOuwP.mjs.map
